import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Form, Dropdown, Row, Col, Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { EditIcon, ShowIcon } from '../../components/icons';
import { toast } from 'react-hot-toast';
import Pagination from 'react-js-pagination';
import Progress from 'react-progress-2';
import 'react-progress-2/main.css';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';
import TableSearch from '../../components/Form/Search';
import ProductImage from '../../components/Form/ProductImage';
import { Loading } from '../../components/Loading';
import DeleteButton from '../../components/commons/DeleteButton';

const ProductList = () => {
      const [loading, setLoading] = useState(false);
      const [products, setProducts] = useState([]);
      const [totalProducts, setTotalProducts] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const token = JSON.parse(localStorage.getItem('token'));
      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState('');

      const fetchProducts = async () => {
            setLoading(true);
            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/products?limit=${limit}&search=${search}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${JSON.parse(
                                          localStorage.getItem('token')
                                    )}`
                              }
                        }
                  )
                  .then((response) => {
                        setProducts(response.data.products);
                        setTotalProducts(response.data.totalProducts);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                        setLoading(false);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };
      useEffect(() => {
            fetchProducts();
      }, [limit, search]);

      const handleStatus = async (finish) => {
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/products/${finish.slug}/status`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      async function getProductData(pageNumber = 1) {
            window.scrollTo(0, 0);
            Progress.show();
            const url = `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/products?page=${pageNumber}&limit=${limit}&search=${search}`;
            await axios(url, {
                  headers: {
                        Authorization: `Bearer ${token}`
                  }
            })
                  .then((response) => {
                        setProducts(response.data.products);
                        setTotalProducts(response.data.totalProducts);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      }

      const handleDelete = async (product) => {
            setLoading(true);
            await axios
                  .delete(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/products/${product.slug}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setProducts([]);
                              fetchProducts();
                              toast.success(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader>
                                          <CardTitle>Product List</CardTitle>
                                          <CardLinks>
                                                <LinkButton
                                                      to="/dashboard/products/create"
                                                      className="me-2"
                                                >
                                                      Add New
                                                </LinkButton>
                                                <Dropdown>
                                                      <Dropdown.Toggle
                                                            variant="secondary"
                                                            className="btn btn-link"
                                                            id="dropdown-basic"
                                                      >
                                                            <i className="bx bx-menu-alt-right"></i>
                                                      </Dropdown.Toggle>

                                                      <Dropdown.Menu className="product__menu">
                                                            <Dropdown.Item as="div">
                                                                  <Link
                                                                        to="/dashboard/products/units"
                                                                        className="d-block"
                                                                  >
                                                                        Unit
                                                                  </Link>
                                                            </Dropdown.Item>
                                                            <Dropdown.Item as="div">
                                                                  <Link
                                                                        to="/dashboard/products/sizes"
                                                                        className="d-block"
                                                                  >
                                                                        Size
                                                                  </Link>
                                                            </Dropdown.Item>
                                                            <Dropdown.Item as="div">
                                                                  <Link
                                                                        to="/dashboard/products/colors"
                                                                        className="d-block"
                                                                  >
                                                                        Color
                                                                  </Link>
                                                            </Dropdown.Item>
                                                            <Dropdown.Item as="div">
                                                                  <Link
                                                                        to="/dashboard/products/import/create"
                                                                        className="d-block"
                                                                  >
                                                                        Create
                                                                        Product
                                                                  </Link>
                                                            </Dropdown.Item>
                                                            <Dropdown.Item as="div">
                                                                  <Link
                                                                        to="/dashboard/products/import/update"
                                                                        className="d-block"
                                                                  >
                                                                        Update
                                                                        Product
                                                                  </Link>
                                                            </Dropdown.Item>
                                                      </Dropdown.Menu>
                                                </Dropdown>
                                          </CardLinks>
                                    </CardHeader>
                                    <Card.Body>
                                          <TableSearch
                                                setLimit={setLimit}
                                                setSearch={setSearch}
                                          />
                                          <Table hover bordered>
                                                <thead>
                                                      <tr>
                                                            {/* <th>#</th> */}
                                                            <th>Name</th>
                                                            <th>
                                                                  Product Code
                                                            </th>
                                                            <th>Price</th>
                                                            <th>Stock</th>
                                                            <th width="80px">
                                                                  Status
                                                            </th>
                                                            <th width="120px">
                                                                  Action
                                                            </th>
                                                      </tr>
                                                </thead>
                                                <tbody>
                                                      {!loading ? (
                                                            products.length >
                                                            0 ? (
                                                                  products.map(
                                                                        (
                                                                              product,
                                                                              index
                                                                        ) => (
                                                                              <>
                                                                                    <tr
                                                                                          key={
                                                                                                index
                                                                                          }
                                                                                    >
                                                                                          {/* <td>{product.index}</td> */}
                                                                                          <td>
                                                                                                <ProductImage
                                                                                                      image={
                                                                                                            product.image
                                                                                                      }
                                                                                                      title={
                                                                                                            product.title
                                                                                                      }
                                                                                                      category={`Category: ${product.category} | Brand: ${product.brand_name}`}
                                                                                                />
                                                                                          </td>
                                                                                          <td>
                                                                                                {
                                                                                                      product.productCode
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                Rs{' '}
                                                                                                {
                                                                                                      product.price
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                {
                                                                                                      product.stock
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                <Form.Check
                                                                                                      type="switch"
                                                                                                      id="custom-switch"
                                                                                                      defaultChecked={
                                                                                                            product.status ===
                                                                                                            1
                                                                                                                  ? true
                                                                                                                  : false
                                                                                                      }
                                                                                                      onClick={() =>
                                                                                                            handleStatus(
                                                                                                                  product
                                                                                                            )
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                          <td className="text-center">
                                                                                                <Link
                                                                                                      to={`/dashboard/products/${product.slug}/edit`}
                                                                                                      className="text-secondary"
                                                                                                >
                                                                                                      <EditIcon />
                                                                                                </Link>
                                                                                                <Link
                                                                                                      to={`/dashboard/products/${product.slug}/show`}
                                                                                                      className="text-success mx-2"
                                                                                                >
                                                                                                      <ShowIcon />
                                                                                                </Link>
                                                                                                <DeleteButton
                                                                                                      item={
                                                                                                            product
                                                                                                      }
                                                                                                      handleDelete={
                                                                                                            handleDelete
                                                                                                      }
                                                                                                      loading={
                                                                                                            loading
                                                                                                      }
                                                                                                      setLoading={
                                                                                                            setLoading
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                    </tr>
                                                                              </>
                                                                        )
                                                                  )
                                                            ) : (
                                                                  <>
                                                                        <tr>
                                                                              <td
                                                                                    colSpan={
                                                                                          6
                                                                                    }
                                                                                    className="text-center"
                                                                              >
                                                                                    No
                                                                                    product
                                                                                    found
                                                                              </td>
                                                                        </tr>
                                                                  </>
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    6
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              <Loading />
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )}
                                                </tbody>
                                          </Table>

                                          <div className="clearfix">
                                                <div className="float-start">
                                                      Showing {perPages} items
                                                      from {totalProducts} items
                                                </div>
                                                <div className="float-end">
                                                      {totalProducts > 10 && (
                                                            <Pagination
                                                                  activePage={
                                                                        currentPage
                                                                  }
                                                                  totalItemsCount={
                                                                        totalProducts
                                                                  }
                                                                  itemsCountPerPage={
                                                                        perPages
                                                                  }
                                                                  onChange={(
                                                                        pageNumber
                                                                  ) =>
                                                                        getProductData(
                                                                              pageNumber
                                                                        )
                                                                  }
                                                                  itemClass="page-item"
                                                                  linkClass="page-link"
                                                                  firstPageText="First"
                                                                  lastPageText="Last"
                                                            />
                                                      )}
                                                </div>
                                          </div>
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default ProductList;
